import { CommonService } from "../../../../../services/CommonService";
import SeniorityLevel from "../../components/SeniorityLevel";
import { order } from "../SmartSearchParammeter";

export default async function SeniorityLevelSearchConfig(key) {
  let seniorityLevels = await CommonService.getAllSeniorityLevels();
  return {
    description: "Seniority Level",
    id: "seniorityLevels",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      searchObject.seniorityLevels = searchObject.seniorityLevels.map((j) => j.id);
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <SeniorityLevel
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    operation: ["Must"],
    list: seniorityLevels.map((j) => j.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      searchObj["seniorityLevels"] = seniorityLevels.filter(
        (j) => value[0] == j.description.replace(/#/g, ",").trim()
      );
    }
  };
}